import axios from 'axios';
export var axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_SERVICE_URL,
  withCredentials: true
});
export var axiosStockInstance = axios.create({
  baseURL: process.env.VUE_APP_SERVICE_STOCK_URL
});
export var googleMapsAxiosInstance = axios.create({});